var map = {
  "./da.json": [
    "39307",
    [
      49784
    ]
  ],
  "./fi.json": [
    "1473",
    [
      72666
    ]
  ],
  "./sv.json": [
    "60642",
    [
      48086
    ]
  ],
  "./ja.json": [
    "48373",
    [
      2134
    ]
  ],
  "./lt.json": [
    "62716",
    [
      39373
    ]
  ],
  "./sl.json": [
    "43443",
    [
      57744
    ]
  ],
  "./fr.json": [
    "67180",
    [
      57309
    ]
  ],
  "./es.json": [
    "12456",
    [
      22993
    ]
  ],
  "./no.json": [
    "34483",
    [
      53968
    ]
  ],
  "./cs.json": [
    "3926",
    [
      69243
    ]
  ],
  "./en.json": [
    "26063",
    [
      73572
    ]
  ],
  "./description/en.json": [
    "51084",
    [
      83805
    ]
  ],
  "./pl.json": [
    "73432",
    [
      78465
    ]
  ],
  "./hu.json": [
    "76331",
    [
      1592
    ]
  ],
  "./nl.json": [
    "31970",
    [
      45503
    ]
  ],
  "./de.json": [
    "82711",
    [
      14300
    ]
  ],
  "./pt.json": [
    "49488",
    [
      55817
    ]
  ],
  "./it.json": [
    "82709",
    [
      1174
    ]
  ],
  "./et.json": [
    "36113",
    [
      76874
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 74241;
module.exports = __rspack_async_context;
